/// <amd-module name="TFS/Admin/Groups/Common/Redux/DataSource/GroupsPivotPermissionsDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { GroupPermissions } from "TFS/Admin/Common/Contracts/OrganizationSettings";

const PermissionsGroupsPivotMetadataProviderId = "ms.vss-admin-web.org-admin-permissions-groups-data-provider";

export function getGroupPermissions(pageContext: IVssPageContext, subjectDescriptor: string): Promise<GroupPermissions | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    // Using ignoreCache = true to make sure we get the latest data from the server on refresh.
    return contributionService
        .getDataAsync<GroupPermissions>(PermissionsGroupsPivotMetadataProviderId, { subjectDescriptor: subjectDescriptor }, true)
        .then(result => {
            return result;
        });
}
